import(/* webpackMode: "eager" */ "/var/www/devrtl/node_modules/.pnpm/next@15.5.9_@playwright+test@1.59.1_react-dom@19.1.0_react@19.1.0__react@19.1.0/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager" */ "/var/www/devrtl/src/components/common/404/index.js");
;
import(/* webpackMode: "eager" */ "/var/www/devrtl/src/components/common/button/index.js");
;
import(/* webpackMode: "eager" */ "/var/www/devrtl/src/components/common/footer/index.js");
;
import(/* webpackMode: "eager" */ "/var/www/devrtl/src/components/common/header/index.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/devrtl/src/components/common/OptimizedImage.js");
;
import(/* webpackMode: "eager" */ "/var/www/devrtl/src/components/common/trading-view-chart/index.jsx");
;
import(/* webpackMode: "eager" */ "/var/www/devrtl/src/components/common/whatsapp-float/index.js");
;
import(/* webpackMode: "eager" */ "/var/www/devrtl/src/components/react-hook-form/dynamic-form.js");
;
import(/* webpackMode: "eager" */ "/var/www/devrtl/src/components/react-hook-form/form-provider.js");
;
import(/* webpackMode: "eager" */ "/var/www/devrtl/src/components/react-hook-form/rhf-checkbox.js");
;
import(/* webpackMode: "eager" */ "/var/www/devrtl/src/components/react-hook-form/rhf-datepicker.js");
;
import(/* webpackMode: "eager" */ "/var/www/devrtl/src/components/react-hook-form/rhf-input.js");
;
import(/* webpackMode: "eager" */ "/var/www/devrtl/src/components/react-hook-form/rhf-media.js");
;
import(/* webpackMode: "eager" */ "/var/www/devrtl/src/components/react-hook-form/rhf-select.js");
;
import(/* webpackMode: "eager" */ "/var/www/devrtl/src/components/transitions/collapse.js");
;
import(/* webpackMode: "eager" */ "/var/www/devrtl/src/components/transitions/fade.js");
;
import(/* webpackMode: "eager" */ "/var/www/devrtl/src/components/transitions/grow.js");
;
import(/* webpackMode: "eager" */ "/var/www/devrtl/src/components/transitions/wiggle.js");
;
import(/* webpackMode: "eager" */ "/var/www/devrtl/src/layouts/index.js");
;
import(/* webpackMode: "eager" */ "/var/www/devrtl/src/lib/common.js");
;
import(/* webpackMode: "eager" */ "/var/www/devrtl/src/lib/hooks.js");
;
import(/* webpackMode: "eager" */ "/var/www/devrtl/src/views/pages/index.js");
;
import(/* webpackMode: "eager", webpackExports: ["SolutionDetailPageRelatedSection"] */ "/var/www/devrtl/src/views/pages/solution-detail/related_solution.js");
